export interface EnumListItem {
  id?: string;
  label: string;
  value: number | string;
  selected: boolean;
  disabled?: boolean;
  readonly?: boolean;
  parent?: string;
  isEllipsis?: boolean;
  additionalData?: { type: number };
}

export interface SelectedOption {
  label: string;
  value: number | string;
}

export enum EnumListEvents {
  SELECTION_CHANGE = 'selectionChange',
  OPTIONS_FILTERED = 'optionsFiltered',
  OPTION_CHANGED = 'optionChanged',
}

export enum GroupType {
  DEFAULT = 'default',
  ACCORDION = 'accordion',
}

export enum ItemType {
  FAKE = -1,
}
